import React, { Dispatch, Fragment, SetStateAction } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import {
  DialogPanel,
  Dialog,
  TransitionChild,
  Transition,
} from "@headlessui/react";
import Button from "../../../componentLibrary/Button";
import { TeamMember } from "./TeamsTab";

type ProfileModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  selectedMember: TeamMember;
};

export default function ProfileModal({
  isModalOpen,
  setIsModalOpen,
  selectedMember,
}: ProfileModalProps) {
  const maxHeight = "90vh";

  return (
    <Transition appear show={isModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 flex items-center justify-center"
        onClose={() => {}}
        static
      >
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <DialogPanel
            className="w-full max-w-sm transform rounded-md bg-gray-50 shadow-xl transition-all"
            style={{ maxHeight }}
          >
            <div className="relative">
              <img
                src={selectedMember?.profileBannerSrc}
                alt={`${selectedMember?.name} profile banner`}
                className="w-full h-48 object-cover overflow-hidden"
                style={{
                  objectPosition:
                    selectedMember?.profileBannerPosition || "center center",
                }}
              />
              <div className="absolute top-2 right-2">
                <Button.Circle
                  variant="secondary"
                  onClick={() => setIsModalOpen(false)}
                >
                  <XMarkIcon className="h-5 w-5" />
                </Button.Circle>
              </div>
              <div className="rounded-md absolute bottom-0 mb-2 left-2 inline-block w-fit bg-gray-100 bg-opacity-50 p-2">
                <div className="text-lg font-bold">{selectedMember?.name}</div>
                <div className="text-sm">{selectedMember?.title}</div>
              </div>
            </div>
            <div
              className="p-2 text-xs whitespace-pre-line overflow-y-auto"
              style={{ maxHeight: `calc(${maxHeight} - 12rem)` }}
            >
              {selectedMember?.description || "No description available."}
            </div>
          </DialogPanel>
        </TransitionChild>
      </Dialog>
    </Transition>
  );
}
